/** Local-only barter demos for Outreach + prospect record (never hit the API as real clients). */

import { MOCK_BARTER_AGREEMENT_FIELDS } from "@/components/BarterAgreementDocument";

export const MOCK_BARTER_INQUIRY_ID = "mock-barter-inquiry-fern";
export const MOCK_BARTER_AGREEMENT_ID = "mock-barter-lumen-clay";

/** Client-facing mock agreement (filled merge fields + sign). */
export const MOCK_BARTER_AGREEMENT_PATH = "/agreement/mock";
/** Studio preview with unsigned / signed / thanks toggles. */
export const MOCK_BARTER_AGREEMENT_STUDIO_PATH = "/agreement/mock-studio";

/** Fresh Inquiry-column barter prospect. */
export function mockBarterInquiryClient() {
  return {
    id: MOCK_BARTER_INQUIRY_ID,
    name: "Fern & Form",
    compensation_type: "barter",
    engagement_stage: "outreach",
    engagement_type: "project",
    service_tier: "brand_design",
    owner: "Taī",
    primary_contact_name: "Sam Rivera",
    primary_contact_email: "sam@fernandform.studio",
    prospect_notes:
      "Local mock · fresh Inquiry barter. Exchange is Barter from day one — brand system in trade for studio photography + product credit.",
    proposal_options: [],
    barter_agreement: {
      status: "draft",
      fields: {
        PARTNER: "Fern & Form",
        FOUNDER: "Sam Rivera",
        START_DATE: "2026-09-01",
        TAISTU_PROVIDES: "Operational Ecosystem",
        TAISTU_VALUE: "$2,500",
        PARTNER_PROVIDES: "studio photography days and ongoing product credit",
        PARTNER_VALUE: "$2,500",
      },
    },
    scope_review: null,
    archived: false,
    status: "active",
    created_at: new Date().toISOString(),
  };
}

/** Agreement-column barter prospect (ready to share / sign). */
export function mockBarterAgreementClient() {
  return {
    id: MOCK_BARTER_AGREEMENT_ID,
    name: "Lumen & Clay",
    compensation_type: "barter",
    engagement_stage: "proposal",
    engagement_type: "monthly",
    service_tier: "operational_ecosystem",
    owner: "Taī",
    primary_contact_name: "Maya Chen",
    primary_contact_email: "maya@lumenandclay.com",
    prospect_notes:
      "Local mock · Agreement-stage barter. Agreement opens the formal barter agreement (filled merge fields + sign). Record shows the prospect UI.",
    proposal_options: [],
    barter_agreement: {
      status: "partner_signed",
      fields: { ...MOCK_BARTER_AGREEMENT_FIELDS },
      shared_at: new Date().toISOString(),
      expires_at: null,
      partner_signed_at: new Date().toISOString(),
      partner_signature: null,
      studio_signed_at: null,
      studio_signature: null,
      signed_at: null,
      signature_name: "Maya Chen",
    },
    scope_review: { status: "pending" },
    archived: false,
    status: "active",
    created_at: new Date().toISOString(),
  };
}

export function allMockBarterClients() {
  return [mockBarterInquiryClient(), mockBarterAgreementClient()];
}

export function isMockBarterClientId(id) {
  return id === MOCK_BARTER_INQUIRY_ID || id === MOCK_BARTER_AGREEMENT_ID;
}

export function getMockBarterClient(id) {
  if (id === MOCK_BARTER_INQUIRY_ID) return mockBarterInquiryClient();
  if (id === MOCK_BARTER_AGREEMENT_ID) return mockBarterAgreementClient();
  return null;
}
